import * as d3 from "d3"
import * as select from "app/core/components/dashboard/d3/select"
import * as shared from "./shared"
import { SvgEventHandlers } from "./types"

export const register = (
  svgElement: SVGSVGElement,
  handlers?: SvgEventHandlers,
  editable?: boolean,
  showSelection?: boolean,
  allowMultiSelect?: boolean,
): (() => void) => {
  d3.select(svgElement).on("click", function (event: MouseEvent) {
    const { textTarget, buttonTarget } = shared.mouseTarget(event)

    // trigger edit event, unless shift/cmd key is being held (which indicates selection edit)
    if (!event.metaKey && !event.shiftKey && textTarget && buttonTarget) {
      if (editable) {
        handlers?.edit?.(buttonTarget, event)
        return
      }
      // if not in edit mode, handle as button click/select
    }
    if (buttonTarget) {
      // we handle selecting the button in the drag start handler
      // because drag will fire both on click and drag
      // except if the dashboard is not editable, the drag handler does not do anything
      // so we will have to handle the selection here
      if (!editable) {
        if (showSelection) {
          if (allowMultiSelect && event.metaKey) {
            select.toggle(buttonTarget)
          } else if (!select.isSelected(buttonTarget)) {
            select.button(buttonTarget, allowMultiSelect && event.shiftKey)
          }
          handlers?.select?.(select.getSelection(), event)
        }
      }
      handlers?.click?.(buttonTarget, event)
    } else {
      if (showSelection && !editable) {
        // not a valid selection target, deselect all
        // only in non-editable mode — in editable mode, drag handles selection
        select.button(undefined)
        handlers?.select?.(select.getSelection(), event)
      }
      handlers?.click?.(undefined, event)
    }
  })

  return () => d3.select(svgElement).on("click", null)
}
